import React from "react";
import Button from "../Button/Button";
import { Modal } from "@mui/material";

const ConfirmModal = ({
  modalButtonTitle,
  className,
  children,
  title,
  functionButton,
  modalWidth,
  onClose,
  disabled,
  leftTopIcon,
  cancelLeft,
  open,
  setOpen,
  titleClasses
}) => {

  const handleClose = () => {
    setOpen(false);
    if (onClose) onClose()
  };

  return (
    <div className={`${modalWidth}`}>
      <Modal
        open={open}
        closeAfterTransition
        onClose={handleClose}
      >
        <div className="flex items-center justify-center h-screen ">
          <div
            className={`bg-paper rounded-2xl p-6 flex flex-col justify-between max-w-[480px] max-h-content ${className}`}>
            <div className="mb-6 border-b-black flex items-center">
              {leftTopIcon}
              <h4 className={`font-sans text-lg-18 ${leftTopIcon ? "ml-[18px]" : ""}  ${titleClasses}`}>{title}</h4>
            </div>
            <div className="font-sans max-h-[503px] overflow-auto text-text-secondary">
              {children}
            </div>
            <div className={`mt-6 flex justify-end space-x-4`}>
              {cancelLeft ?

                <>
                  <Button onClick={handleClose} type="outlined" size="md" width="w-max">Cancel</Button>
                  <Button
                    classes="bg-primary-error-600"
                    hover="hover:bg-primary-error-500" size="md" width="w-max"
                    disabled={disabled} onClick={() => {
                      functionButton()
                      handleClose()
                    }}>{modalButtonTitle}</Button>
                </>
                :
                <>
                  <Button
                    classes="bg-primary-error-600"
                    hover="hover:bg-primary-error-500" size="md" width="w-max"
                    disabled={disabled} onClick={() => {
                      functionButton()
                      handleClose()
                    }}>{modalButtonTitle}</Button>
                  <Button onClick={handleClose} type="outlined" size="md" width="w-max">Cancel</Button>
                </>
              }

            </div>
          </div>
        </div>
      </Modal>
    </div>
  )

}
export default ConfirmModal
